import * as React from "react";
import { cn } from "./cn";

export type TextareaProps =
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    invalid?: boolean;
  };

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, invalid, rows = 3, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        "w-full resize-y rounded-[var(--radius-sm)] border-[1.5px] px-4 py-3 text-[15px]",
        "font-satoshi font-medium text-ink placeholder:text-ash",
        "bg-mist border-smoke outline-none transition-colors",
        "focus:border-lime focus:bg-paper",
        "disabled:cursor-not-allowed disabled:opacity-60",
        invalid && "border-danger focus:border-danger",
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
